export enum ChatEntryPoint {
	SEARCH_PAGE_AUTO_OPEN_CHAT = 'searchPageAutoOpenChat',
	SEARCH_PAGE_SUMMARIZE_IN_CHAT = 'searchPageSummarizeInChat',
}
